import PATH from "constants/path";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTitleDecoration } from "utils/common";
import { getPromotion } from "features/Promotion/promotionSlice";
import { no_image } from "assets/img";
import { SERVICE } from "constants/global";
import Partner from "features/Promotion/components/Partner";
import { isAuthenticated } from "utils/common";
import ErrorDB from "components/ErrorDB";

const Promotion = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const pathname = useLocation().pathname;
  const { id } = useParams();

    // redux store
  const { promotion, promotion_set, isInLine } = useSelector((state) => state.promotion);

  const _PATH_PROMOTION = "promotions";
  const pathURL = pathname.split("/")[1];
  const isTop = pathURL === _PATH_PROMOTION;
  // title
  let title = pathURL === _PATH_PROMOTION ? "モニター募集" : "応募中案件";
  // href back
  let hrefBack = pathURL === _PATH_PROMOTION ? PATH.TOP : PATH.ENTRIES;
  // handle back page fit with path URL
  const handleBack = () => {
    history.push(hrefBack);
  };

  useEffect(() => {
    if (id) {
      dispatch(getPromotion({ service: SERVICE, id, isTop }));
    }
  }, []);

  if (!promotion && !isInLine) return null;

  return (
    <>
      <div className="w-80">
        {/* TITLE */}
        <div className="border-sticky border-news-no-top bg-f4 p-2 p-md-2 text-grey">
          <div className="position-relative text-center fs-14 fw-600">
            {title}
            <div
              onClick={handleBack}
              className="d-flex position-absolute start-0 top-0 cursor-pointer"
            >
              <i className="bi bi-chevron-left"></i>
              <span className="d-none d-md-block">戻る</span>
            </div>
          </div>
        </div>

        <div className="px-3 px-md-0 my-2">
          {
            isInLine ?
            <ErrorDB/>
            :
            <div>
              <div className="mb-3 fs-18 fs-sm-16 fw-600">
              {/* DECORATION */}
              <span
                className="me-1"
                dangerouslySetInnerHTML={{
                  __html: getTitleDecoration(
                    promotion?.title_decoration?.title_decoration_content
                  ),
                }}
              ></span>

              {/* TITLE */}
              {promotion?.title_login}
              </div>

              {/* IMAGE */}
              <div className="wrapper-img mb-3">
                <img
                  src={
                    promotion.file_big_login
                      ? promotion.file_big_login
                      : no_image
                  }
                  alt={promotion.title_login}
                />
              </div>

              {/* DESRIPTION */}
              <div
                dangerouslySetInnerHTML={{
                  __html: promotion?.description_login,
                }}
              ></div>
            </div>
          }
          

        {isAuthenticated() && isTop ? (
          <Partner />
        ) : null}
        </div>

       
        {/*  GROUP BUTTON APPLY ENTRIES */}
        {/* {can_entry === true && (
          <div className="group-btn-custom my-5">
            <a href={PATH.TOP} className="btn-custom after">
              戻る
            </a>
            <div
              onClick={() => setModalOpen("modal-submit")}
              className="btn-custom red-light before"
            >
              この案件に応募する
            </div>
          </div>
        )} */}
      </div>

      {/* MODAL */}
      {/* <ModalSubmit
        open={modalOpen === "modal-submit"}
        handleModal={setModalOpen}
      />
      <ModalConfirm
        open={modalOpen === "modal-confirm"}
        handleModal={setModalOpen}
      /> */}
    </>
  );
};

export default Promotion;
